import React, { useState } from "react";
class CommonUtil {
  isEdit = false;
  showMessageOnPopUp = false;
  isErrorOnSave = false;
  hideModalPopUp(buttonId) {
    document.getElementById(buttonId).click();
    //this.setIsEdit(false);
  }

  setIsEdit(val) {
    this.isEdit = val;
  }

  getIsEdit() {
    return this.isEdit;
  }

  setShowMessageOnPopUp(val) {
    this.showMessageOnPopUp = val;
  }

  getShowMessageOnPopUp() {
    return this.showMessageOnPopUp;
  }

  getIsErrorOnSave() {
    return this.isErrorOnSave;
  }

  setIsErrorOnSave(val) {
    this.isErrorOnSave = val;
  }

  isUserWebsiteAdmin() {
    return sessionStorage.getItem("isWebsiteAdmin") === "true";
  }

  isUserOrganisationAdmin() {
    return sessionStorage.getItem("roleId") === "1";
  }

  isUserWerkAdmin() {
    return sessionStorage.getItem("roleId") === "2";
  }
  isSupportUser() {
    return sessionStorage.getItem("roleId") === "6";
  }
  isManageTicketUser() {
    return sessionStorage.getItem("roleId") === "7";
  }
  hasManageTicketPermission() {
    return sessionStorage.getItem("isManageTicket") === "true";
  }
  isPrufer() {
    return sessionStorage.getItem("roleId") === "4";
  }
  isAdmin() {
    return sessionStorage.getItem("roleId") === "3";
  }
  isReader() {
    return sessionStorage.getItem("roleId") === "5";
  }
}
export default new CommonUtil();
